import MobileDraggableItem from './MobileDraggableItem';

export default MobileDraggableItem;
